module.exports = __webpack_public_path__ + "static/media/c3bannerModulF_small.12dc7f4d.jpg";